import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import withTheme from '@mui/styles/withTheme';
import withStyles from '@mui/styles/withStyles';
import { useLocation, useNavigate, useParams } from "react-router-dom"

import API from "services/Api";
import { DISCIPLINES } from 'constants/constants.js'
import Header from "components/layout/Header";
import Footer from "components/layout/Footer";
import { IDLE, LOADING } from "constants/page-state";
import Spinner from "components/layout/Spinner";
import Sections from "components/layout/Sections";
import ParticipantScoreRankingOD from "./ParticipantScoreRankingOD";
import useIsMobile from "components/hooks/hooks"

const styles = (theme) => ({
  title: {
    marginBottom: theme.spacing(2),
  },
  main: {
    minHeight: "30vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  sectionSelect: {
    width: "90%",
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(1),
  },
  lastUpdated: {
    textAlign: "left",
  },
  table: {
    width: "80%",
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      width: "100%",
    },
  },
  cellPos: {
    padding: 0,
    maxWidth: 32,
  },
  rankingContainer: {
    width: "80%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
});

const RankingOD = (props) => {
  const { discipline } = useParams()
  const disciplineName = DISCIPLINES[discipline]
  const { classes } = props
  const navigate = useNavigate();
  const [pageState, setPageState] = useState(LOADING);

  const [years, setYears] = useState({});
  const [sections, setSections] = useState([]);
  const [ranking, setRanking] = useState([]);
  const [updated, setUpdated] = useState("");

  const { pathname, search } = useLocation();
  const [queryParams, setQueryParams] = useState({
    year: null,
    section: null,
  })
  const { isMobile } = useIsMobile();

  useEffect(() => {
    setPageState(LOADING)
    API.rankingOD
      .getRanking(discipline, queryParams.year, queryParams.section)
      .then((res) => {
        setYears(Object.values(res.years).reduce((obj, item) => ({...obj, [item]: item}), {}));
        if (res.sections) {
          setSections(res.sections)
        }
        if (res.ranking) {
          setRanking(res.ranking)
          setUpdated(res.updated)
        }
        setPageState(IDLE)
      })
      .catch((error) => {
        console.error("Error loading api ranking OD " + discipline, error);
      });
  }, [discipline, queryParams])

  useEffect(() => {
    if (search) {
      setQueryParams(Object.fromEntries(new URLSearchParams(search)));
    }
  }, [search])

  if (queryParams.year === null && Object.values(years).length === 1) {
    navigate(`${pathname}?${(new URLSearchParams({"year": Object.values(years)[0]})).toString()}`, { replace: true });
  }

  const changeSelectSection = (key, type) => {
    let query = {};
    if (type === "year") {
      query["year"] = key;
    } else if (type === "section") {
      query = {
        year: queryParams.year,
        section: key,
      }
    }

    navigate(`${pathname}?${(new URLSearchParams(query)).toString()}`, { replace: true });
  }

  return (
      <Box>
        <Header></Header>
        <Box className={classes.main}>
          <Typography className={classes.title} variant="h4">
            Ranking { disciplineName }
          </Typography>

          {Object.keys(years).length > 0 ? (
            <Box className={classes.sectionSelect}>
              <Sections
                title="Seleccione año"
                isMobile={isMobile}
                sections={years}
                currentValue={queryParams.year || ""}
                changeSelectSection={(event) => changeSelectSection(event.target.value, "year")}
                changeButtonGroupSection={(index) => changeSelectSection(index, "year")}
              />
            </Box>
          ) : "Ranking no disponible" }

          {Object.keys(sections).length > 0 && (
            <Box className={classes.sectionSelect}>
              <Sections
                title="Seleccione sección"
                isMobile={isMobile}
                sections={sections}
                currentValue={queryParams.section || ""}
                changeSelectSection={(event) => changeSelectSection(event.target.value, "section")}
                changeButtonGroupSection={(index) => changeSelectSection(index, "section")}
              />
            </Box>
          )}

          { pageState === LOADING && <Spinner /> }

          {ranking && ranking.length > 0 && (
            <div className={classes.rankingContainer}>
              <Typography className={classes.lastUpdated} variant="body1">
                Último ranking publicado: { updated }
              </Typography>
              <Table className={classes.table}>
                {!isMobile && (
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.cellPos} align="center">
                        POS.
                      </TableCell>
                      <TableCell>EJEMPLAR</TableCell>
                      <TableCell>JINETE</TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          <b>TITULAR</b>
                        </Typography>
                        <Typography variant="body2">
                          <b>CRIADOR</b>
                        </Typography>
                      </TableCell>
                      <TableCell>PUNTUACIONES</TableCell>
                      <TableCell>TOTAL</TableCell>
                    </TableRow>
                  </TableHead>
                )}

                <TableBody>
                  { ranking.map((p, i) => (
                      <ParticipantScoreRankingOD
                        key={i}
                        participant={p}
                        section={queryParams.section}
                        isMobile={isMobile}
                      ></ParticipantScoreRankingOD>
                    ))}
                </TableBody>
              </Table>
            </div>
          )}
        </Box>
        <Footer></Footer>
      </Box>
  );
}

export default withTheme(withStyles(styles)(RankingOD));
